module.exports = __webpack_public_path__ + "static/media/po-lub-5.a37db5eb.png";